export class OTA_DriverType {
    public code: number;
    public age: number;
    public quantity: number;
}
